import type { Locker, TemperatureDemoScenario } from "shared/locker"

/** LOCKER-534 — the demo contract lives on `LockerAttrs` (`shared/locker.d.ts`). */
export type { TemperatureDemoScenario } from "shared/locker"

/** Scenario choice in the setup dialog: `off` = the door has no simulated reading. */
export type TemperatureDemoChoice = TemperatureDemoScenario | "off"

export const TEMPERATURE_DEMO_CHOICES: TemperatureDemoChoice[] = [
  "off",
  "normal",
  "warning",
  "critical",
  "past",
]

/** True only when a super admin switched the demo on for this locker. */
export const isTemperatureDemoEnabled = (locker?: Locker | null): boolean =>
  locker?.temperatureDemo?.enabled === true

const NO_DOORS: Record<string, TemperatureDemoScenario> = {}

/**
 * The door → scenario map to RENDER. Empty when the demo is off, whatever the
 * stored map holds: the gate is `temperatureDemo.enabled`, never the map alone.
 */
export const activeTemperatureDemoDoors = (
  locker?: Locker | null,
): Record<string, TemperatureDemoScenario> => {
  if (!isTemperatureDemoEnabled(locker)) return NO_DOORS
  return locker?.temperatureDemoDoors ?? NO_DOORS
}
